export const BAG_ADDED='BAG_ADDED';
export const SELECT_LRT_BAGTYPE = 'SELECT_LRT_BAGTYPE';